import React, { useState, createContext } from 'react';
import moment from 'moment';
import 'moment/locale/ur';
import 'moment/locale/sd';
import romn from "../languageConfig/local/romn";
import snd from "../languageConfig/local/snd";
import en from "../languageConfig/local/en";
import ur from "../languageConfig/local/ur";

const localLang = localStorage.getItem('language') || 'en';
let lang = {};
lang = en;

const MOMENT_LOCALE_BY_I18N = new Map([
    [ur, 'ur'],
    [snd, 'sd'],
]);

// <html lang> for the selected language, so screen readers and the browser's translate
// prompt know the page language (it was always "en" before)
const HTML_LANG_BY_I18N = new Map([
    [en, 'en'],
    [ur, 'ur'],
    [romn, 'ur-Latn'],
    [snd, 'sd'],
]);
const setHtmlLang = (i18n) => {
    document.documentElement.lang = HTML_LANG_BY_I18N.get(i18n) || 'en';
};

// Urdu dates ("22 اکتوبر 2026") sit in left-to-right layouts, which flips their order. Wrapping
// every formatted string that contains Urdu text in a right-to-left isolate (U+2067…U+2069)
// shows it the Urdu way everywhere moment formats. Number-only formats ("YYYY-MM-DD" for APIs)
// have no Urdu letters, so they stay untouched; preparse strips the marks so parsing still works.
const URDU_LETTERS = /[؀-ۿ]/;
const urLocaleData = moment.localeData('ur');
const urPostformat = urLocaleData.postformat.bind(urLocaleData);
const urPreparse = urLocaleData.preparse.bind(urLocaleData);
moment.updateLocale('ur', {
    postformat: (string) => {
        const formatted = urPostformat(string);
        return URDU_LETTERS.test(formatted) ? `\u2067${formatted}\u2069` : formatted;
    },
    preparse: (string) => urPreparse(String(string).replace(/[\u2067\u2069]/g, '')),
    // moment's Urdu only has صبح (before 12) and شام (after), so 2 PM showed "شام" and 11 PM too.
    // Use the everyday split instead; meridiemHour keeps parsing these back to the right hour.
    meridiemParse: /صبح|دوپہر|شام|رات/,
    meridiem: (hour) => {
        if (hour < 4) return 'رات';
        if (hour < 12) return 'صبح';
        if (hour < 16) return 'دوپہر';
        if (hour < 19) return 'شام';
        return 'رات';
    },
    meridiemHour: (hour, meridiem) => {
        if (hour === 12) hour = 0;
        if (meridiem === 'صبح') return hour;
        if (meridiem === 'دوپہر') return hour < 4 || hour === 0 ? hour + 12 : hour;
        if (meridiem === 'شام') return hour + 12;
        return hour < 4 ? hour : hour + 12; // رات: 1–3 is after midnight, otherwise night
    },
});

moment.locale(localLang === 'ur' ? 'ur' : localLang === 'snd' ? 'sd' : 'en');

const initialI18n = localLang === 'ur' ? ur : localLang === 'snd' ? snd : localLang === 'romn' ? romn : en;
setHtmlLang(initialI18n);

export const LanguageContext = createContext();

export const LanguageProvider = (props) => {
    const [I18n, setI18n] = useState(initialI18n);

    const changeLanguage = (newI18n) => {
        moment.locale(MOMENT_LOCALE_BY_I18N.get(newI18n) || 'en');
        setHtmlLang(newI18n);
        setI18n(newI18n);
    };

    return (
        <LanguageContext.Provider value={[I18n, changeLanguage]}>
            {props.children}
        </LanguageContext.Provider>
    )
}